import { toast } from "../../components/ui/use-toast";
import axios from "axios";
import { CircleCheckBig } from "lucide-react";
import { z } from "zod";
const baseUrl = process.env.REACT_APP_SERVER_URL;

export const getAllBudget = async () => {
  try {
    const response = await axios.get(`${baseUrl}/api/budgets`);
    return { budgets: response.data.budgets };
  } catch (error) {
    console.error(error);
  }
};

export const fechAllBudget = async (page: number, category: string) => {
  try {
    const response = await axios.get(
      `${baseUrl}/api/budgets/all?page=${page}&category=${category}`
    );
    return {
      data: response.data.budgets,
      totalPages: response.data.totalPages,
      totalCount: response.data.totalCount,
    };
  } catch (error) {
    console.error(error);
  }
};

export const deleteBudget = async (id: number) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    };
    const response = await axios.delete(`${baseUrl}/api/budgets/${id}`, config);
    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">
            {response.data.message}
          </span>
        </div>
      ),
    });

    return response;
  } catch (error) {
    console.error(error);
  }
};

export const handleCreateBudget = async (formData: any, navigate: Function) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const newsFormData = new FormData();

    for (const key in formData) {
      if (formData.hasOwnProperty(key) && key !== "file") {
        if (formData[key] !== undefined && formData[key] !== null) {
          if (Array.isArray(formData[key])) {
            newsFormData.append(key, JSON.stringify(formData[key]));
          } else {
            newsFormData.append(key, formData[key]);
          }
        }
      }
    }

    if (formData.file && formData.file.file) {
      newsFormData.append("file", formData.file.file);
    }

    const response = await axios.post(
      `${baseUrl}/api/budgets/`,
      newsFormData,
      config
    );

    toast({
      variant: "destructive",
      className: "bg-green-500 border border-green-500",
      description: (
        <div className="flex items-center">
          <CircleCheckBig className="mr-2" />
          <span className="first-letter:capitalize">{response.data.msg}</span>
        </div>
      ),
    });
    navigate("/admin-dashboard/budgets");
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const handleUpdateBudgets = async (
  id: number,
  formData: any,
  navigate: Function
) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "Content-Type": "multipart/form-data",
      },
    };

    const formDataToSend = new FormData();
    formDataToSend.append("title", formData.title);
    formDataToSend.append("description", formData.description);
    formDataToSend.append("date", formData.date);
    formDataToSend.append("category", formData.category);

    if (formData.file) {
      formDataToSend.append("file", formData.file.file);
    }

    const response = await axios.patch(
      `${baseUrl}/api/budgets/${id}`,
      formDataToSend,
      config
    );
    toast({
      variant: "destructive",
      title: "Opération réussie.",
      description: response.data.msg,
      className: "bg-green-500 border border-green-500",
    });
    navigate("/admin-dashboard/budgets");
  } catch (error: any) {
    if (error instanceof z.ZodError) {
      const fieldErrors: { [key: string]: string } = {};
      error.errors.forEach((err: any) => {
        fieldErrors[err.path[0]] = err.message;
      });
    } else {
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        toast({
          variant: "destructive",
          title: "Une erreur s'est produite.",
          description: error.response.data.message,
          className: "bg-red-500 border border-red-500",
        });
        return error.response.data.message;
      }
    }
  }
};

export const getBudgetById = async (id: number) => {
  try {
    const response = await axios.get(`${baseUrl}/api/budgets/${id}`);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
